import { Address } from "./address.model"
import { PropertyRoom } from "./propertyRoom.model"

export interface LandlordData {
    name: string
    surname: string
    phoneNumber: string
    email: string
    oib: string
    residenceAddress: Address
    propertyRooms: PropertyRoom[]
    areaOfProperty: number
    iban: string
    swift: string
    startRentDate: Date | null
    endRentDate: Date | null
    isApartmentOfLegalEntity: boolean
    rentalPropertyAddress: Address
    monthlyRent: number
    consentForm: string
    catastarKO: string
    catastarCE: string
    ownershipCertificate: string
    submitted: boolean
}

export enum LandlordDataKeys {
    Name = "name",
    Surname = "surname",
    PhoneNumber = "phoneNumber",
    Email = "email",
    OIB = "oib",
    ResidenceAddress = "residenceAddress",
    PropertyRooms = "propertyRooms",
    AreaOfProperty = "areaOfProperty",
    Iban = "iban",
    Swift = "swift",
    StartRentDate = "startRentDate",
    EndRentDate = "endRentDate",
    IsApartmentOfLegalEntity = "isApartmentOfLegalEntity",
    RentalPropertyAddress = "rentalPropertyAddress",
    MonthlyRent = "monthlyRent",
    ConsentForm = "consentForm",
    CatastarKO = "catastarKO",
    CatastarCE = "catastarCE",
    OwnershipCertificate = "ownershipCertificate",
    Submitted = "submitted",
}